<template>
    <div class="relative">
        <draggable :list="estimate.scopeOfWorks" draggable=".draggable" @change="sectionsReordered"
                   class="flex flex-wrap items-center -m-3">
            <div v-for="(section,index) in estimate.scopeOfWorks" class="m-1" :class="estimate.readonly?'':'draggable'">
                <div v-if="index === activeSectionIndex" class="flex">
                    <div class="relative">
                        <autoresizable-input measure="font-medium text-sm" ref="resizer">
                            <input
                                placeholder="..."
                                type="text"
                                ref="tabTitleInput"
                                :disabled="estimate.readonly"
                                v-model="section.title"
                                @input="estimate.update()"
                                @change="estimate.addSnapshot()"
                                @keydown.enter.prevent="$emit('change', $event.target.value);$event.target.blur()"
                                class="relative inline-block box-content m-0 border-0 shadow-none px-3 pl-2 font-medium text-sm rounded-l-md bg-blue-100 text-blue-700 focus:z-20 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                style="min-width: 20px;"
                                :style="estimate.readonly?'cursor:pointer':''"
                                :class="section.optional ? 'pr-20' : 'pr-2'"
                            >
                        </autoresizable-input>
                        <div
                            v-if="section.optional"
                            @click="$refs['input'+index][0].focus()"
                            class="absolute z-20 right-0 inset-y-0 flex items-center justify-center w-20 italic font-semibold text-xs text-blue-700 tracking-wider"
                        >optional
                        </div>
                    </div>
                    <ui-dropdown menu-class="p-3 w-60" class="flex" trigger-class="flex">
                        <template #default="{ toggle }">
                            <button @click="toggle"
                                    class="p-2 font-medium text-xs rounded-r-md bg-blue-100 text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600">
                                <i class="fa fa-chevron-down fa-fw"></i>
                            </button>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item icon="fas fa-adjust" @click="toggleOptional(section, close)"
                                              v-if="!estimate.readonly">
                                {{ section.optional ? 'Remove optional' : 'Make optional' }}
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-calculator"
                                              @click="$modals.open('estimate-section-cost-list', { section, estimate })">
                                See Cost Breakdown
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fas fa-cut" @click="cutSection(section);close();"
                                              v-if="!estimate.readonly">Cut Section
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-copy" @click="copySection(section);close();">Copy Section
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-paste"
                                              v-if="!estimate.readonly && (estimateClipboard[0])"
                                              @click="pasteSection(estimateClipboard[0],section);close();">
                                Paste Section
                            </ui-dropdown-item>
                            <ui-dropdown-divider v-if="!estimate.readonly"></ui-dropdown-divider>
                            <ui-dropdown-item ref="paste1item"
                                              @mouseleave="closePasteSubMenu(1)"
                                              @mouseenter="openPasteSubMenu(1)"
                                              v-if="!estimate.readonly"
                                              icon="fas fa-clipboard"
                                              :submenu="true"
                            >Library
                                <div class="fixed" style="width:auto;height:auto;overflow: visible;"
                                     :ref="'paste1relative'">
                                    <vue-context :ref="'paste1menu'" :autoFocus="false"
                                                 class="inline pb-0 focus:outline-none focus:ring-0 z-50"
                                                 :close-on-click="false" :close-on-scroll="false">
                                        <div :id="'paste1menu'"
                                             class="p-3 w-72 z-50 bg-white rounded-lg border border-gray-300 shadow-lg">
                                            <ui-dropdown-item icon="fas fa-plus"
                                                              @click="addToLibrary(section);close();">
                                                Add Section to Library
                                            </ui-dropdown-item>
                                            <ui-dropdown-divider
                                                v-if="!estimate.readonly && (estimateClipboard.length > 1)"></ui-dropdown-divider>
                                            <ui-dropdown-item icon="fas fa-paste"
                                                              button-class="truncate"
                                                              class="w-full truncate flex"
                                                              v-for="(item,i) in estimateClipboard"
                                                              :key="'paste1-'+i"
                                                              v-if="i > 0"
                                                              @click="pasteSection(item.data,section);close();">
                                                <div class="text-xs text-blue-500 truncate">{{ item.name }}</div>
                                            </ui-dropdown-item>
                                        </div>
                                    </vue-context>
                                </div>
                            </ui-dropdown-item>
                            <ui-dropdown-divider v-if="!estimate.readonly"></ui-dropdown-divider>
                            <ui-dropdown-item v-if="!estimate.readonly" icon="fas fa-trash"
                                              danger @click="deleteSection(section);close();">Delete
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </div>
                <div v-else class="flex">
                    <div class="relative" @click="select(index)" style="cursor: pointer">
                        <autoresizable-input measure="font-medium text-sm" ref="resizer" v-if="!estimate.readonly">
                            <input
                                placeholder="..."
                                disabled
                                type="text"
                                v-model="section.title"
                                class="relative inline-block box-content m-0 border-0 shadow-none px-3 pl-2 font-medium text-sm rounded-l-md focus:z-20 focus:outline-none focus:ring-2"
                                style="min-width: 20px;cursor: pointer"
                                :class="section.optional ? 'pr-20' : 'pr-2'"
                            >
                        </autoresizable-input>
                        <div v-else
                             v-text="section.title"
                             class="relative inline-block box-content mt-1 ml-0 m-0 border-0 shadow-none px-3 pl-2 font-medium text-sm rounded-l-md focus:z-20 focus:outline-none focus:ring-2"
                             :class="section.optional ? 'pr-20' : 'pr-2'"
                        ></div>
                        <div
                            v-if="section.optional"
                            @click="$refs['input'+index][0].focus()"
                            class="absolute z-20 right-0 inset-y-0 flex items-center justify-center w-20 italic font-semibold text-xs tracking-wider"
                        >optional
                        </div>
                    </div>
                    <ui-dropdown menu-class="p-3 w-60" class="flex" trigger-class="flex">
                        <template #default="{ toggle }">
                            <button @click="toggle"
                                    class="p-2 font-medium text-xs rounded-r-md text-gray-300 focus:outline-none">
                                <i class="fa fa-chevron-down fa-fw"></i>
                            </button>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item icon="fas fa-adjust" @click="toggleOptional(section, close)"
                                              v-if="!estimate.readonly">
                                {{ section.optional ? 'Remove optional' : 'Make optional' }}
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-calculator"
                                              @click="$modals.open('estimate-section-cost-list', { section, estimate })">
                                See Cost Breakdown
                            </ui-dropdown-item>
                            <ui-dropdown-divider></ui-dropdown-divider>
                            <ui-dropdown-item icon="fas fa-cut" @click="cutSection(section);close();"
                                              v-if="!estimate.readonly">Cut Section
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-copy" @click="copySection(section);close();">Copy Section
                            </ui-dropdown-item>
                            <ui-dropdown-item icon="fas fa-paste"
                                              v-if="!estimate.readonly && (estimateClipboard[0])"
                                              @click="pasteSection(estimateClipboard[0],section);close();">
                                Paste Section
                            </ui-dropdown-item>
                            <ui-dropdown-divider v-if="!estimate.readonly"></ui-dropdown-divider>
                            <ui-dropdown-item :ref="'paste'+(index+20)+'item'"
                                              @mouseleave="closePasteSubMenu((index+20))"
                                              @mouseenter="openPasteSubMenu((index+20))"
                                              v-if="!estimate.readonly"
                                              icon="fas fa-clipboard"
                                              :submenu="true"
                            >Library
                                <div class="fixed" style="width:auto;height:auto;overflow: visible;"
                                     :ref="'paste'+(index+20)+'relative'">
                                    <vue-context :ref="'paste'+(index+20)+'menu'" :autoFocus="false"
                                                 class="inline pb-0 focus:outline-none focus:ring-0 z-50"
                                                 :close-on-click="false" :close-on-scroll="false">
                                        <div :id="'paste'+(index+20)+'menu'"
                                             class="p-3 w-72 z-50 bg-white rounded-lg border border-gray-300 shadow-lg">
                                            <ui-dropdown-item icon="fas fa-plus"
                                                              @click="addToLibrary(section);close();">
                                                Add Section to Library
                                            </ui-dropdown-item>
                                            <ui-dropdown-divider
                                                v-if="!estimate.readonly && (estimateClipboard.length > 1)"></ui-dropdown-divider>
                                            <ui-dropdown-item icon="fas fa-paste"
                                                              button-class="truncate"
                                                              class="w-full truncate flex"
                                                              v-for="(item,i) in estimateClipboard"
                                                              :key="'paste'+(index+20)+'-'+i"
                                                              v-if="i > 0"
                                                              @click="pasteSection(item.data,section);close();">
                                                <div class="text-xs text-blue-500 truncate">{{ item.name }}</div>
                                            </ui-dropdown-item>
                                        </div>
                                    </vue-context>
                                </div>
                            </ui-dropdown-item>
                            <ui-dropdown-divider v-if="!estimate.readonly"></ui-dropdown-divider>
                            <ui-dropdown-item v-if="! estimate.readonly" icon="fas fa-trash"
                                              danger @click="deleteSection(section);close();">Delete
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </div>
            </div>
            <div slot="footer" class="m-3" v-if="!estimate.readonly">
                <button
                    class="group px-3 py-2 inline-flex items-center space-x-2 font-medium text-sm rounded-md text-gray-400 hover:text-gray-700"
                    @click="add">
                    <i class="fa fa-plus text-sm text-gray-300 group-hover:text-gray-500"></i>
                    <div>New</div>
                </button>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {Estimate} from "../../../models"
import {cloneDeep} from "lodash"
import UiDropdownItem from "../../ui/UiDropdownItem.vue"
import remoteStorage from "../../../utils/remoteStorage"
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue"
import {toCurrency} from "../../../utils"

export default {
    components: {
        UiDropdownDivider,
        UiDropdownItem,
        draggable
    },
    props: {
        estimate: Estimate,
        sectionIndex: null,
        defaultScrollOffsetData: [],
    },
    data() {
        let estimateClipboardData = []
        try {
            estimateClipboardData = remoteStorage.getItem('estimate-section-clipboard') ? JSON.parse(remoteStorage.getItem('estimate-section-clipboard')) : []
        } catch (e) {
            //continue on JSON ERROR
        }

        return {
            activeSectionIndex: this.sectionIndex,
            activePage: 'summary',
            scrollOffsetData: [],
            estimateClipboard: estimateClipboardData,
        }
    },
    methods: {
        cutSection(section) {
            this.estimateClipboard[0] = section
            remoteStorage.setItem('estimate-section-clipboard', JSON.stringify(this.estimateClipboard))
            remoteStorage.setItem('estimate-clipboard-view', 'section')
            this.deleteSection(section)
        },
        copySection(section) {
            this.estimateClipboard[0] = cloneDeep(section)
            remoteStorage.setItem('estimate-section-clipboard', JSON.stringify(this.estimateClipboard))
            remoteStorage.setItem('estimate-clipboard-view', 'section')
        },
        closePasteSubMenu(num) {
            const p = "paste" + num + "menu"
            if (this.$refs[p][0]) {
                this.$refs[p][0].close()
            } else {
                this.$refs[p].close()
            }
        },
        openPasteSubMenu(num) {
            const p = "paste" + num + "menu"
            if (this.$refs[p][0]) {
                this.$refs[p][0].open(new window.MouseEvent('mouse'))
            } else {
                this.$refs[p].open(new window.MouseEvent('mouse'))
            }
            this.positionPasteMenu(num)
        },
        pasteSection(section, at) {
            remoteStorage.setItem('estimate-clipboard-view', 'section')
            let num = Math.max(0, this.estimate.scopeOfWorks.indexOf(at))
            this.estimate.scopeOfWorks.splice(num, 0, cloneDeep(section))
            this.estimate.update()
            this.estimate.addSnapshot()
            this.select(num)
        },
        addToLibrary(section) {
            this.$modals.open(
                'estimate-add-item-to-library',
                {
                    name: (section.title + ' (' + toCurrency(section.total) + ')').replace(/(\r\n|\n|\r)/gm, ""),
                    title: `Add Section to Library`,
                    button: 'Add Section',
                    useGroups: false,
                    handle: (name, group) => {
                        this.estimateClipboard.push({
                            name: name,
                            data: cloneDeep(section)
                        })
                        remoteStorage.setItem('estimate-section-clipboard', JSON.stringify(this.estimateClipboard))
                        remoteStorage.setItem('estimate-clipboard-view', 'section')
                    }
                }
            )
        },
        positionPasteMenu(num) {
            this.$nextTick(() => {
                if (this.$refs["paste" + num + "relative"][0]) {
                    this.$refs["paste" + num + "relative"][0].setAttribute('style', '')
                } else {
                    this.$refs["paste" + num + "relative"].setAttribute('style', '')
                }
                this.$nextTick(() => {
                    let opener, box
                    if (this.$refs["paste" + num + "item"][0]) {
                        opener = this.$refs["paste" + num + "item"][0].$refs.submenu.getBoundingClientRect()
                    } else {
                        opener = this.$refs["paste" + num + "item"].$refs.submenu.getBoundingClientRect()
                    }
                    if (this.$refs["paste" + num + "menu"][0]) {
                        box = this.$refs["paste" + num + "menu"][0].$el.getBoundingClientRect()
                    } else {
                        box = this.$refs["paste" + num + "menu"].$el.getBoundingClientRect()
                    }
                    let left = Math.min(opener.x - box.x - 10, window.innerWidth - (box.right) - 17)
                    let top = Math.min(opener.y - box.y - 10, window.innerHeight - (box.bottom) - 28)
                    if (this.$refs["paste" + num + "relative"][0]) {
                        this.$refs["paste" + num + "relative"][0].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                    } else {
                        this.$refs["paste" + num + "relative"].setAttribute('style', 'margin-left:' + left + 'px; margin-top:' + top + 'px')
                    }
                })
            })
        },
        add() {
            const newSection = {
                title: `Untitled Section ${this.estimate.scopeOfWorks.length + 1}`,
                defaultTitle: `Untitled Section ${this.estimate.scopeOfWorks.length + 1}`,
                tasks: [],
                order: this.estimate.scopeOfWorks.length,
                ref: null,
                custom_ref: null,
                optional: false,
            }
            this.estimate.scopeOfWorks.push(newSection)
            this.estimate.update()
            this.estimate.addSnapshot()
            this.resizeTabs()
            this.select(this.estimate.scopeOfWorks.length - 1)
            this.$nextTick(() => {
                const input = this.$refs.tabTitleInput[this.$refs.tabTitleInput.length - 1]
                input.focus()
                input.select()
            })
        },
        deleteSection(section) {
            this.estimate.scopeOfWorks = this.estimate.scopeOfWorks.filter((s) => s !== section)
            this.estimate.update()
            this.estimate.addSnapshot()
            if (this.estimate.scopeOfWorks.length) {
                this.select(Math.min(this.activeSectionIndex, this.estimate.scopeOfWorks.length - 1))
            }
        },
        select(sectionIndex) {
            let target = cloneDeep(this.scrollOffsetData[sectionIndex])
            if (this.activeSectionIndex !== null) {
                this.scrollOffsetData[0 + this.activeSectionIndex] = document.getElementById('ui-crud-main-body').scrollTop
            } else {
                this.scrollOffsetData['page'] = document.getElementById('ui-crud-main-body').scrollTop
            }
            this.resizeTabs()
            this.$emit('updating', this.scrollOffsetData)
            this.$emit('update:active-section-index', sectionIndex)
            this.activeSectionIndex = sectionIndex
            this.$nextTick(() => {
                window.requestAnimationFrame(() => {
                    document.getElementById('ui-crud-main-body').scrollTop = 0 + target
                    this.$nextTick(() => {
                        document.activeElement.blur()
                    })
                })
            })
        },
        sectionsReordered(evt) {
            if (evt.moved) {
                if (evt.moved.oldIndex === this.activeSectionIndex) {
                    this.select(evt.moved.newIndex)
                } else if ((evt.moved.oldIndex - this.activeSectionIndex) * (evt.moved.newIndex - this.activeSectionIndex) <= 0) {
                    if (evt.moved.oldIndex > evt.moved.newIndex) {
                        this.select(this.activeSectionIndex + 1)
                    } else {
                        this.select(this.activeSectionIndex - 1)
                    }
                }
                this.estimate.update()
                this.resizeTabs()
                this.estimate.addSnapshot()
            }
        },
        resizeTabs() {
            this.$nextTick(() => {
                if (this.$refs.resizer) {
                    this.$refs.resizer.forEach((e, i) => e.resizeInput(e.$el))
                }
            })
        },
        toggleOptional(section, close) {
            section.optional = !section.optional
            close()
            this.estimate.update()
            this.estimate.addSnapshot()
        },
        scroller() {
            this.scrollOffsetData[0 + this.activeSectionIndex] = document.getElementById('ui-crud-main-body').scrollTop;
        }
    },
    beforeUpdate() {
        this.resizeTabs()
        if (this.activeSectionIndex + 1 > this.estimate.scopeOfWorks.length) {
            if (this.estimate.scopeOfWorks.length) {
                this.select(this.estimate.scopeOfWorks.length - 1)
            }
        }
    },
    mounted() {
        this.scrollOffsetData = this.defaultScrollOffsetData
        this.$nextTick(() => {
            window.requestAnimationFrame(() => {
                document.getElementById('ui-crud-main-body').scrollTop = 0 + this.scrollOffsetData[this.activeSectionIndex]
                this.$nextTick(() => {
                    window.addEventListener('scroll', this.scroller, true);
                    this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', this.scroller, true))
                })
            })
        })
    },
    beforeDestroy() {
        this.$emit('updating', this.scrollOffsetData)
    }
}
</script>
<style lang="css">
input[disabled] {
    pointer-events: none
}
</style>

